import type { SlackMessage } from '../systems/EventBus';

/**
 * Jamie's four time-triggered Slack messages, in order.
 * fictionalMinutes maps to the in-game clock (540 = 9:00 AM, 1020 = 5:00 PM).
 */
export const JAMIE_MESSAGES: readonly SlackMessage[] = [
  {
    id: 'jamie-opening',
    author: 'jamie',
    body: "morning! ok so — first close. breathe. open the AR Aging window — that's where you start. i'm around if anything gets weird 🙃",
    fictionalMinutes: 540,
  },
  {
    id: 'jamie-short-pay',
    author: 'jamie',
    body: "btw — when a wire comes in for the wrong amount like that, we call it a short-pay. it's like half my life. you'll see.",
    fictionalMinutes: 678,
  },
  {
    id: 'jamie-lunch',
    author: 'jamie',
    body: "eating? don't forget.",
    fictionalMinutes: 750,
  },
  {
    id: 'jamie-dispute',
    author: 'jamie',
    body: "that was a dispute. we log everything, even the weird ones.",
    fictionalMinutes: 752,
  },
  {
    id: 'jamie-pre-close',
    author: 'jamie',
    body: 'last stretch. stay with me.',
    fictionalMinutes: 990,
  },
  {
    id: 'jamie-closing',
    author: 'jamie',
    body: "you did good today. first close down. it doesn't get easier — you just get faster. tomorrow 9am, same thing.",
    fictionalMinutes: 1020,
  },
];
